export const timelineEn = {
  buttonGantt: 'Gantt',
  buttonCalendar: 'Calendar',
  boardViewHint: 'Open board view',
  calendarViewHint: 'Open calendar view',
  timelineViewHint: 'Open timeline view',
  toggleUnscheduled: 'Tasks without deadline',
  addStart: 'Add start date',
  removeStart: 'Remove start date',
  addUserToProject: 'Added user to project',
  removeUserFromProject: 'Removed user from project',
  changedProjectPermissions: 'Changed project permissions',
  changedRolesInProject: 'Changed roles in project',
  addUsers: 'Adding users',
  removeUsers: 'Removing users',
  // new
  columnTitle: 'Name',
  columnAssigned: 'Asne.',
  columnAssignedFull: 'Assigned',
  columnDateRange: 'Date Range',
  columnLength: 'Wrk.Days',
  addTaskBtn: 'Add task',
  taskTitlePlaceholder: 'Enter task name',
  addColumnBtn: 'Add column',
  columnTitlePlaceholder: 'Enter column name',
  boardTitlePlaceholder: 'Enter board name',
  scale: {
    days: 'Days',
    weeks: 'Weeks',
    months: 'Months',
    years: 'Years'
  },
  removeLink: 'Remove',
  removeLink2: 'Remove link',
  scrollToToday: 'Today',
  ganttSettings: 'Gantt Settings',
  settingsAutoPlanning: 'Auto planning',
  autoPlanningPopup: {
    title: 'Attention!',
    content:
      'If a task has links and task deadlines overlap, they will be offset',
    checkboxTitle: "Don't show this message again"
  },
  errorLinkCycleEncountered:
    'The task has cyclic links. Remove one of the links that create the loop to continue.',
  errorCannotCreateLinkCycle: 'Cannot create a cycle with task links',
  stickerDeadlineStartLockedTooltip:
    'It is not possible to change the start date of this task because it depends on another task',
  stickerDeadlineBlockedBy:
    'Deadline is not set, selection of start date is blocked by dependency in Gantt',
  autoPlanningTooltip:
    'Auto planning feature turns on automatic start date recalculation for tasks that depend on other tasks',
  lag: 'Lag',
  lagTooltip: 'Set the delay/overlap in days from the end of the dependent task'
}

export const timelineRu: typeof timelineEn = {
  buttonGantt: 'Гант',
  buttonCalendar: 'Календарь',
  boardViewHint: 'Переключиться на вид доски',
  calendarViewHint: 'Переключиться на вид календаря',
  timelineViewHint: 'Переключиться на вид Ганта',
  toggleUnscheduled: 'Задачи без дедлайна',
  addStart: 'Добавить дату начала',
  removeStart: 'Убрать дату начала',
  addUserToProject: 'Добавлен пользователь в проект',
  removeUserFromProject: 'Удалён пользователь из проекта',
  changedProjectPermissions: 'Изменены доступы в проекте',
  changedRolesInProject: 'Изменены роли в проекте',
  addUsers: 'Добавление пользователей',
  removeUsers: 'Удаление пользователей',
  // new
  columnTitle: 'Название',
  columnAssigned: 'Исп.',
  columnAssignedFull: 'Исполнитель',
  columnDateRange: 'Диапазон дат',
  columnLength: 'Раб.дней',
  addTaskBtn: 'Добавить задачу',
  taskTitlePlaceholder: 'Введите название задачи',
  addColumnBtn: 'Добавить раздел',
  columnTitlePlaceholder: 'Введите название раздела',
  boardTitlePlaceholder: 'Введите название доски',
  scale: {
    days: 'Дни',
    weeks: 'Недели',
    months: 'Месяцы',
    years: 'Годы'
  },
  removeLink: 'Удалить',
  removeLink2: 'Удалить связь',
  scrollToToday: 'Сегодня',
  settingsAutoPlanning: 'Автопланирование',
  ganttSettings: 'Настройки Ганта',
  autoPlanningPopup: {
    title: 'Внимание!',
    content:
      'Если у задачи установлены связи и сроки задач накладываются, они будут смещены',
    checkboxTitle: 'Больше не показывать это сообщение'
  },
  errorLinkCycleEncountered:
    'У задачи есть циклические связи. Уберите одну из связей создающих цикл чтобы продолжить',
  errorCannotCreateLinkCycle: 'Нельзя создать циклические связи задач',
  stickerDeadlineStartLockedTooltip:
    'Невозможно изменить дату начала этой задачи, поскольку она зависит от другой задачи',
  stickerDeadlineBlockedBy:
    'Дедлайн не задан, выбор даты начала заблокирован зависимостью в Ганте',
  autoPlanningTooltip:
    'Автопланирование включает автоматический пересчет даты старта задачи при создании зависимости с другой задачей на доске',
  lag: 'Лаг',
  lagTooltip: 'Заложить задержку/наложение в днях от окончания зависимой задачи'
}
